<!-- Parcelas: subseção com o Adicionar no cabeçalho. -->
<div class="sub-section-container">
  <div class="sub-section-title">
    <mat-icon class="material-symbols-outlined">event_repeat</mat-icon>
    <span>Parcelas</span>
    @if (!isSomenteLeitura) {
      <div class="section-title-actions ms-auto">
        <button mat-button type="button" class="btn-section" (click)="adicionar()">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
          Adicionar
        </button>
      </div>
    }
  </div>

  @if (!linhas.length) {
    <app-empty-state icon="event_repeat" title="Nenhuma parcela lançada"
      subtitle="Informe a condição de pagamento e gere as parcelas, ou adicione uma linha.">
    </app-empty-state>
  } @else {
    <div [formGroup]="recebimento">
      <div formArrayName="parcelas" (keydown.enter)="$event.preventDefault()">
        @for (linha of linhas; track linha; let i = $index) {
          <div class="vpc-linha" [formGroupName]="i">
            <!-- Parcela n/total, com o marcador de observação (§8.7.1): só quando preenchida,
                 e a coluna não reserva espaço vazio. -->
            <div class="vpc-col-numero">
              <span class="vpc-numero">{{ i + 1 }}/{{ linhas.length }}</span>
              @if (temObservacao(linha)) {
                <mat-icon class="material-symbols-outlined vpc-comentario"
                  [matTooltip]="linha.get('observacao')?.value" tabindex="0">comment</mat-icon>
              }
              @if (pendenciaObrigatoria(linha); as pendencia) {
                <mat-icon class="material-symbols-outlined vpc-pendencia" [matTooltip]="pendencia" tabindex="0">error</mat-icon>
              }
            </div>

            <div class="vpc-col-dias">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Dias</mat-label>
                <input matInput formControlName="dias" [currencyMask]="mascaraInteira" class="vpc-num"
                  [readonly]="isSomenteLeitura" (blur)="aoSairDosDias(i)">
              </mat-form-field>
            </div>

            <div class="vpc-col-venc">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Vencimento</mat-label>
                <input matInput formControlName="dataVencimento" [matDatepicker]="dp" placeholder="DD/MM/AAAA"
                  [readonly]="isSomenteLeitura"
                  (input)="onDateInput($event, linha.get('dataVencimento'))"
                  (dateChange)="aoMudarVencimento(i)" (blur)="aoMudarVencimento(i)">
                <mat-datepicker-toggle matSuffix [for]="dp" [disabled]="isSomenteLeitura"></mat-datepicker-toggle>
                <mat-datepicker #dp></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="vpc-col-valor">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Valor</mat-label>
                <input matInput formControlName="valor" [currencyMask]="mascaraDinheiro" class="vpc-num"
                  [readonly]="isSomenteLeitura" (blur)="aoSairDoValor(i)">
              </mat-form-field>
            </div>

            <!-- Ações à direita, do mesmo tamanho das ações da lista de itens (§8.7). -->
            <div class="vpc-col-acoes">
              <button type="button" mat-icon-button class="icon-mat-symbols-btn" matTooltip="Editar parcela" (click)="editar(i)">
                <mat-icon class="material-symbols-outlined">edit</mat-icon>
              </button>
              <button type="button" mat-icon-button class="icon-mat-symbols-btn" matTooltip="Excluir parcela"
                [disabled]="isSomenteLeitura" (click)="remover(i)">
                <mat-icon class="material-symbols-outlined">delete</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
